// removed by extract-text-webpack-plugin
module.exports = {"borderBg":"#eee"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 128